// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Paginator_Pagination__Ln_39","Info":"Paginator_Info__2JtX_","Buttons":"Paginator_Buttons__3-rQC","Button":"Paginator_Button__1pPWf","Prev":"Paginator_Prev__3Voeh"};